import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useLanguage } from '../hooks/useLanguage'

export function BackToTopButton() {
  const { t } = useLanguage()
  const location = useLocation()
  const [visible, setVisible] = useState(false)
  const hasBottomNav = ['/', '/calendar', '/markets', '/event-plan'].includes(location.pathname)

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 480)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleBackToTop = () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    })
  }

  if (!visible) {
    return null
  }

  return (
    <button
      type="button"
      aria-label={t('回到顶部', 'Back to top')}
      onClick={handleBackToTop}
      className={`fixed right-4 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-gray-900 text-lg font-semibold text-white shadow-lg shadow-gray-900/20 transition-colors duration-200 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:bg-gray-950 dark:bg-white dark:text-gray-950 dark:hover:bg-gray-100 ${
        hasBottomNav ? 'bottom-[calc(4.5rem+env(safe-area-inset-bottom))]' : 'bottom-5'
      }`}
    >
      ↑
    </button>
  )
}
